import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import {ImpersonationService} from '../services/shared/impersonation.service';
import {RoutingService} from '../services/routing.service';

@Injectable({
  providedIn: 'root'
})
export class LpViewAsInvestorGuard  {

  constructor(private routingService: RoutingService,
              private router: Router,
              private impersonationService: ImpersonationService) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.impersonationService.isViewingAsInvestor) {
      return this.router.createUrlTree([this.routingService.lpHoldingsPage]);
    }

    return true;
  }
}
